<template>
  <div class="text-left px-6 pb-12 bg-gray-50">
    <div class="absolute mt-11" @click="back">
      <back-arrow-icon :width="'w-4'" :height="'h-4'"></back-arrow-icon>
    </div>
    <div class="text-center text-sm font-extrabold w-full pt-12">PAYMENT</div>
    <div class="pt-7">
      <div class="text-xxs text-nw-ash" v-if="promo_code != ''">
        Add a promo code
        <span
          class="pl-4"
          :class="{ 'text-red-500': !validCode, 'text-green-500': validCode }"
          v-if="promo_code.length == 6"
          >{{ validCode ? code.percentage + '% off' : 'Not Valid or Expired' }}</span
        >
      </div>
      <input-text type="text" v-model="promo_code" placeholder="Add a promo code"></input-text>
    </div>
    <div class="pt-3">
      <p class="text-base font-extrabold border-b border-nw-dark pb-3">Bill Summary</p>
    </div>
    <div class="pt-3 pl-6">
      <p class="text-sm border-b pb-3">
        Promo discount
        <span class="float-right"> &#8358;{{ promo_discount }}</span>
      </p>
    </div>
    <div class="pt-3 pl-6">
      <p class="text-sm border-b pb-3">
        Subtotal <span class="float-right"> &#8358;{{ subtotal }}</span>
      </p>
    </div>
    <div class="pt-3 pl-6">
      <p class="text-sm font-bold border-b pb-3">
        Total <span class="float-right"> &#8358;{{ total() }}</span>
      </p>
    </div>
    <div class="pt-3">
      <p class="text-base font-extrabold border-b border-nw-dark pb-3">Payment Methods</p>
    </div>
    <div class="pt-4" @click="pickUp">
      <div class="pr-5 inline-block">
        <naira-note-icon></naira-note-icon>
      </div>
      <div class="text-sm font-bold inline-block">Pay on Pick-up</div>
      <div class="float-right">
        <round-check-icon v-if="payment_types.pick_up"></round-check-icon>
        <div v-if="!payment_types.pick_up" class="rounded-2xl p-2 border border-nw-red"></div>
      </div>
    </div>
    <div class="pt-4" @click="byDelivery">
      <div class="pr-5 inline-block">
        <naira-note-icon></naira-note-icon>
      </div>
      <div class="text-sm font-bold inline-block">Pay on Delivery</div>
      <div class="float-right">
        <round-check-icon v-if="payment_types.delivery"></round-check-icon>
        <div v-if="!payment_types.delivery" class="rounded-2xl p-2 border border-nw-red"></div>
      </div>
    </div>
    <div class="pt-4" @click="withCard">
      <div class="pr-5 inline-block">
        <card-icon></card-icon>
      </div>
      <div class="text-sm font-bold inline-block">Pay with Card</div>
      <div class="float-right">
        <round-check-icon v-if="payment_types.card"></round-check-icon>
        <div v-if="!payment_types.card" class="rounded-2xl p-2 border border-nw-red"></div>
      </div>
    </div>
    <div class="pt-20 text-xs" @click="next">
      <input-button>CONTINUE</input-button>
    </div>
    <div class="fixed left-0 top-0 w-full bg-dark-transparent h-screen" v-if="loading">
      <div class="absolute top-2/4 w-full">
        <loading :width="'w-10'" :height="'h-10'"></loading>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import { mapState } from 'vuex'
import BackArrowIcon from '../icons/BackArrowIcon.vue'
import CardIcon from '../icons/CardIcon.vue'
import NairaNoteIcon from '../icons/NairaNoteIcon.vue'
import RoundCheckIcon from '../icons/RoundCheckIcon.vue'
import InputButton from '../inputs/InputButton.vue'
import InputText from '../inputs/InputText.vue'
import Loading from '../icons/Loading.vue'
export default {
  props: {
    id: [String, Number],
    details: Object
  },
  components: {
    BackArrowIcon,
    InputText,
    RoundCheckIcon,
    NairaNoteIcon,
    CardIcon,
    InputButton,
    Loading
  },
  data() {
    return {
      promo_code: '',
      payment_types: {
        pick_up: false,
        delivery: false,
        card: false
      },
      payment_type: null,
      distance: 0,
      loading: true
    }
  },
  watch: {
    details() {
      this.placePayment()
    },
    promo_code(val) {
      this.$store.dispatch('promo/confirmCode', val.toUpperCase())
    },
    distance(val) {
      if (val == 0) {
        this.beforeTotal()
      } else {
        this.loading = false
      }
    }
  },
  computed: {
    ...mapState('promo', ['code']),
    validCode() {
      if (this.code) {
        var nowDate = new Date()
        var promoExpiration = new Date(this.code.expiration_date)
        var answer = promoExpiration > nowDate
      } else {
        answer = false
      }

      return answer
    },
    promo_discount() {
      if (this.validCode) {
        var discount = (this.code.percentage * this.subtotal) / 100
      } else {
        discount = 0
      }

      return parseInt(discount)
    },
    subtotal() {
      const pricing = this.details?.delivering?.region_details?.cost
      if (!pricing) return 0

      const baseDistance = Number(pricing.base_distance?.distance || 0) * 1000
      const basePrice = Number(pricing.base_price?.price || 0)
      const perKm = Number(pricing.per_km || 0)

      if (this.distance < baseDistance) {
        return Math.trunc(basePrice)
      }

      const diffInDistance = (this.distance - baseDistance) / 1000
      return Math.trunc(basePrice + diffInDistance * perKm)
    }
  },
  methods: {
    back() {
      this.$emit('show-details', true)
    },
    neutral() {
      this.payment_types.pick_up = false
      this.payment_types.delivery = false
      this.payment_types.card = false
    },
    pickUp() {
      this.neutral()
      this.payment_types.pick_up = true
      this.payment_type = 'On pick up'
    },
    byDelivery() {
      this.neutral()
      this.payment_types.delivery = true
      this.payment_type = 'On delivery'
    },
    withCard() {
      this.neutral()
      this.payment_types.card = true
      this.payment_type = 'With card'
    },
    total() {
      return parseInt(this.subtotal) - parseInt(this.promo_discount)
    },
    next() {
      if (this.validator()) {
        var payment_details = {
          id: this.id,
          payment_type: this.payment_type,
          promo_code: this.promo_code,
          subtotal: this.subtotal,
          total: this.total()
        }
        this.$store.dispatch('add_payment_details/addPaymentDetails', payment_details)
        this.$emit('show-summary', true)
      }
    },
    validator() {
      if (this.payment_type != null) {
        return true
      } else {
        Swal.fire('', 'Select Payment Mode', 'info')
      }
    },
    placePayment() {
      if (this.details.payment_details != undefined) {
        if (this.details.payment_details.payment_type == 'On delivery') {
          this.byDelivery()
        } else if (this.details.payment_details.payment_type == 'On pick up') {
          this.pickUp()
        } else if (this.details.payment_details.payment_type == 'With card') {
          this.withCard()
        }
        this.promo_code = this.details.payment_details.promo_code
        this.subtotal = this.details.payment_details.subtotal
      }
    },
    async beforeTotal() {
      try {
        // eslint-disable-next-line no-undef
        const { RouteMatrix } = await google.maps.importLibrary('routes')

        const origin = {
          // eslint-disable-next-line no-undef
          waypoint: new google.maps.LatLng(this.details.pick_up.coordinates.lat, this.details.pick_up.coordinates.lng),
          routeModifiers: {
            avoidHighways: false,
            avoidTolls: false
          }
        }

        // eslint-disable-next-line no-undef
        const destination = new google.maps.LatLng(
          this.details.delivering.coordinates.lat,
          this.details.delivering.coordinates.lng
        )

        const response = await RouteMatrix.computeRouteMatrix({
          origins: [origin],
          destinations: [destination],
          travelMode: 'DRIVING',
          fields: ['distanceMeters', 'durationMillis']
        })

        const result = response?.matrix?.rows?.[0]?.items?.[0]

        if (!result) {
          throw new Error('No route matrix result returned')
        }

        if (result.error) {
          throw new Error(result.error.message || 'Route matrix item failed')
        }

        this.distance = result.distanceMeters || 0
        this.duration = result.durationMillis || 0
      } catch (error) {
        console.error('Route matrix failed:', error)
        this.distance = 0
        this.loading = false
      }
    }
  },
  beforeMount() {
    this.beforeTotal()
  },
  mounted() {
    this.placePayment()
  }
}
</script>

<style></style>
